<template>
  <a-modal
    :width="400"
    :visible="visible"
    title="部门搜索"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
  >
    <!--部门树-->
    <template>
      <a-form :form="form">
        <a-form-item
          :labelCol="{ xs: { span: 24 }, sm: { span: 5 } }"
          :wrapperCol="{ xs: { span: 24 }, sm: { span: 16 } }"
          label="上级部门"
        >
          <a-tree
            multiple
            treeCheckable="tree"
            checkable
            @expand="onExpand"
            :expandedKeys="expandedKeysss"
            :checkedKeys="checkedKeys"
            allowClear="true"
            :checkStrictly="true"
            @check="onCheck"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="departTree"
            placeholder="请选择上级部门"
          >
          </a-tree>
        </a-form-item>
      </a-form>
    </template>
  </a-modal>
</template>

<script>
import pick from "lodash.pick";
import { findAllDepts } from "@/api/system/dept";
export default {
  name: "DeptModal",
  data() {
    return {
      checkedKeys: [], // 存储选中的部门id
      expandedKeysss: [], //展开的节点
      userId: "", // 存储用户id
      model: {}, // 存储SysUserDepartsVO表
      userDepartModel: { userId: "", departIdList: [] }, // 存储用户id一对多部门信息的对象
      deptList: [], // 存储部门信息
      departTree: [],
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    add(checkedDepartKeys, userId) {
      this.checkedKeys = checkedDepartKeys;
      this.userId = userId;
      this.edit({});
    },
    edit(record) {
      this.deptList = [];
      this.queryDepartTree();
      this.form.resetFields();
      this.visible = true;
      this.model = Object.assign({}, record);
      let filedsVal = pick(this.model, "id", "userId", "departIdList");
      this.$nextTick(() => {
        this.form.setFieldsValue(filedsVal);
      });
    },
    close() {
      this.$emit("close");
      this.visible = false;
      this.deptList = [];
      this.checkedKeys = [];
    },
    handleSubmit(e) {
      const that = this;
      e.preventDefault();
      this.form.validateFields(error => {
        if (error) {
          console.log("error", error);
        } else {
          that.confirmLoading = true;
          let formData = { deptList: this.deptList };
          this.$emit("ok", formData);
          that.confirmLoading = false;
          this.close();
        }
      });
    },
    handleCancel() {
      this.close();
    },
    // 选择部门时作用的API
    onCheck(checkedKeys, info) {
      this.deptList = [];
      this.checkedKeys = checkedKeys.checked;
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data;
        let depart = { key: "", value: "", title: "" };
        depart.key = de.key;
        depart.value = de.key;
        depart.title = de.props.title;
        this.deptList.push(depart);
      }
    },
    //遍历部门数
    queryDepartTree() {
      findAllDepts().then(res => {
        if (res.resultCode == 1) {
          this.departTree = res.result;
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach(item => {
                treekey.push(item.key);
                /*     if(item.children&&item.children.length>0){
                    item.children.forEach(item1 => {
                      treekey.push(item1.key);
                    })
                  }*/
              });
              this.expandedKeysss = treekey;
            }
          }
        }
      });
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
    },
    modalFormOk() {}
  }
};
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
